export default __webpack_public_path__ + "static/Digital_IDA_Branded_Tearsheet_Final Upload-292146239d3b38755f7dec7fd4fa59be.pdf";